import LoLShareButton from './LoLShareButton';

export default LoLShareButton;
